module.exports = __webpack_public_path__ + "img/open-pre.8357dd29.png";